import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep15 = (state) => state.get('step15');

const makeSelectStep15 = () =>
  createSelector(selectStep15, (step15State) => ({
    givePermission: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'givePermission']),
      ''
    ),

    thirdPartyTitle: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyTitle']),
      ''
    ),
    thirdPartyFirstName: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyFirstName']),
      ''
    ),
    thirdPartySurName: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartySurName']),
      ''
    ),
    thirdPartyDateOfBirth: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyDateOfBirth']),
      ''
    ),
    thirdPartyRelationShip: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyRelationShip']),
      ''
    ),
    thirdPartyAddressLine1: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyAddressLine1']),
      ''
    ),
    thirdPartyAddressLine2: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyAddressLine2']),
      ''
    ),
    thirdPartyCity: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyCity']),
      ''
    ),
    thirdPartyState: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyState']),
      ''
    ),
    thirdPartyPostal: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyPostal']),
      ''
    ),
    thirdPartyMobilePhone: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyMobilePhone']),
      ''
    ),
    thirdPartyHomePhone: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyHomePhone']),
      ''
    ),
    thirdPartyWorkPhone: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyWorkPhone']),
      ''
    ),
    thirdPartyEmail: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'thirdPartyEmail']),
      ''
    ),
    preferredContactEmailForClaim: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'preferredContactEmailForClaim']),
      ''
    ),
    preferredContactNumberForClaim: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'preferredContactNumberForClaim']),
      ''
    ),
    preferredContactForClaim: mapWithDefault(
      step15State,
      () => step15State.getIn(['form', 'preferredContactForClaim']),
      ''
    ),
  }));

const makeSelectStep15Dirty = () =>
  createSelector(selectStep15, (state) => state.get('dirty'));
export { makeSelectStep15, makeSelectStep15Dirty };



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step15/selectors.js